import React, {Component} from 'react';
import BasicLayout from "../../views/MainLayout";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {getCurrentUser} from "../../redux-actions/auth";
import FeeView from "../../fragments/FeeView";

class FeePage extends Component {
    componentDidMount() {
        this.props.getCurrentUser()
    }

    render() {
        const {user} = this.props;
        return (
            <BasicLayout>
                <FeeView user={user}/>
            </BasicLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.auth.user,
})

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getCurrentUser,
    },
    dispatch,
)


FeePage = connect(mapStateToProps, mapDispatchToProps)(FeePage)
export default FeePage

